import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Editor } from '@tiptap/react'
import React from 'react'

import { RichTextInputProps } from '@/components/form/RichTextInput'
import { Button } from '@/components/ui/button'
import { faList } from '@/lib/fontAwesomePro/regular'
import { cn } from '@/lib/utils'

interface Props {
  editor: Editor
  variant: RichTextInputProps['variant']
}

const EditorToolbar: React.FC<Props> = ({ editor, variant }) => {
  return (
    <section className="flex gap-1">
      <ToolbarButton
        className={cn(
          'font-bold',
          editor.isActive('bold') ? 'text-white' : undefined,
        )}
        isActive={editor.isActive('bold')}
        onClick={() => editor.chain().focus().toggleBold().run()}
      >
        B
      </ToolbarButton>

      <ToolbarButton
        className="italic"
        isActive={editor.isActive('italic')}
        onClick={() => editor.chain().focus().toggleItalic().run()}
      >
        I
      </ToolbarButton>

      <ToolbarButton
        className="underline"
        isActive={editor.isActive('underline')}
        onClick={() => editor.chain().focus().toggleUnderline().run()}
      >
        U
      </ToolbarButton>

      {variant === 'advanced' && (
        <ToolbarButton
          isActive={editor.isActive('bulletList')}
          onClick={() => editor.chain().focus().toggleBulletList().run()}
        >
          <FontAwesomeIcon icon={faList} />
        </ToolbarButton>
      )}
    </section>
  )
}

type ToolbarButtonProps = React.ComponentProps<typeof Button> & {
  isActive: boolean
}

const ToolbarButton: React.FC<ToolbarButtonProps> = ({
  isActive,
  className,
  ...props
}) => (
  <Button
    variant={isActive ? 'black' : 'outline-secondary'}
    className={cn('flex items-center justify-center', className)}
    size="sm"
    style={{ width: '25px', height: '25px' }}
    {...props}
  ></Button>
)

export default EditorToolbar
